import React from 'react';
import Button from 'shared/components/Button';
import { useSelector } from 'react-redux';
import { onToggleFollows } from 'app/routes/Dashboard/actions/user';
import { getError } from 'utils/appHelpers';
import { useAlert } from 'react-alert';
import { useTranslation } from 'react-i18next';
import AvatarImg from 'shared/components/AvatarImg';

const UserInfoBlock = ({ user, getUserData, className }) => {
  const account = useSelector(state => state.account);
  const isOwnerAccount = account.id === user.id;

  const { t } = useTranslation();
  const alert = useAlert();

  const onHandleFollowToggle = async () => {
    try {
      await onToggleFollows(user);
      getUserData(user.id);
    } catch (err) {
      alert.error(getError(err));
    }
  };

  const follows = useSelector(state => state.follows);
  const followersCount = user.followers.items.length;
  const followingCount = user.followees.items.length;
  const userFollowing = follows.following[user.id];

  return (
    <div
      className={`bg-gray-light p-md-15 py-10 px-8 rounded-10 d-flex flex-wrap justify-content-between ${className ||
        ''}`}
    >
      <div className='col-12 col-md-none d-flex flex-wrap justify-content-around text-center text-md-left justify-content-md-start'>
        <div className='rounded-100p text-center'>
          <AvatarImg width='120px' height='120px' size='xl' picture={user.picture} name={user.name} />
        </div>
        <div className='ml-md-15 col-12 col-md-none p-0'>
          <p className='text-lg fw-500 mb-6 pt-5'>{user.name}</p>
          <div className='col-12 col-md-none p-0 justify-content-around mt-3 mt-md-0 d-flex'>
            <div className='mr-md-49 col-6 col-md-none p-0 border-right border-md-none'>
              <p className='mb-4 fw-500'>{t('text_followers')}</p>
              <p className='mb-4'>{followersCount}</p>
            </div>
            <div className='col-6 col-md-none p-0'>
              <p className='mb-4 fw-500'>{t('text_following')}</p>
              <p className='mb-4'>{followingCount}</p>
            </div>
          </div>
        </div>
      </div>
      <div className='col-12 col-md-none mt-10 mt-md-0'>
        {!isOwnerAccount && (
          <Button onClick={onHandleFollowToggle} className='btn-primary'>
            {userFollowing ? t('btn_unfollow') : t('btn_follow')}
          </Button>
        )}
      </div>
    </div>
  );
};

export default UserInfoBlock;
